/** 微信个人号连接配置；扫码结果只由所属实例服务保存。 */
export interface WechatConfig {
  enabled: boolean;
  botToken: string;
  accountId: string;
  baseUrl: string;
  debug?: boolean;
}
/** connected仅表示最近一次真实长轮询成功，启用配置不代表在线。 */
export interface WechatGatewayStatus {
  connected: boolean;
  startedAt: number | null;
  lastError: string | null;
  accountId: string | null;
  lastInboundAt: number | null;
  lastOutboundAt: number | null;
}
/** 扫码接口不返回botToken，也不接受客户端指定归属或任意服务地址。 */
export interface IMPairingSnapshot {
  id: string;
  qrUrl: string;
  status: 'waiting' | 'scanned' | 'success' | 'expired';
  expiresAt: number;
  accountId?: string;
}
export const DEFAULT_WECHAT_CONFIG: WechatConfig = { enabled: false, botToken: '', accountId: '', baseUrl: 'https://ilinkai.weixin.qq.com', debug: false };
export const DEFAULT_WECHAT_STATUS: WechatGatewayStatus = { connected: false, startedAt: null, lastError: null, accountId: null, lastInboundAt: null, lastOutboundAt: null };
